{
	"emptyProductFeatureForm": {
		"description": "Seleccione una plantilla de información de producto personalizada. Para crear un nuevo modelo, acceda a la",
		"link": "Modelos de funcionalidad del producto.",
		"title": "No hay ningún modelo de funcionalidad seleccionado"
	}
}
